import React, { Component } from 'react'
// ui
import { Table, Tag } from 'antd'
import Button from '../../../components/uielements/button'
// redux
import { connect } from 'react-redux'
import userActions from '../../../redux/user/actions'
// const
import { default_avatar } from '../../../redux/user/reducer'

// render column

class ListUsers extends Component {
    _onShowDetail = user => {
        this.props.updateCurrentUser(user)
        this.props.showDetailModal()
    }

    render() {
        let { listUserInOrgani, currentOrganization } = this.props

        const renderPositionColumn = uid => {
            let boss_id = currentOrganization.boss_id
            let deputy_id = currentOrganization.deputy_id
            if (uid === boss_id)
                return (
                    <Tag key="text" color={'red'}>
                        {'Cấp Trưởng'}
                    </Tag>
                )
            if (deputy_id.find(item => item === uid))
                return (
                    <Tag key="text" color={'green'}>
                        {'Cấp Phó'}
                    </Tag>
                )
            return (
                <Tag key="text" color={'blue'}>
                    {'Nhân Viên'}
                </Tag>
            )
        }

        const renderRankColumn = rank_id => {
            const dataRank = [
                {
                    rank_id: 0,
                    rank_name: 'Binh nhì',
                },
                {
                    rank_id: 1,
                    rank_name: 'Binh nhất',
                },
                {
                    rank_id: 2,
                    rank_name: 'Hạ sĩ',
                },
                {
                    rank_id: 3,
                    rank_name: 'Trung sĩ',
                },
                {
                    rank_id: 4,
                    rank_name: 'Thượng sĩ',
                },
                {
                    rank_id: 5,
                    rank_name: 'Học viên',
                },
                {
                    rank_id: 6,
                    rank_name: 'Thiếu úy',
                },
                {
                    rank_id: 7,
                    rank_name: 'Trung úy',
                },
                {
                    rank_id: 8,
                    rank_name: 'Thượng úy',
                },
                {
                    rank_id: 9,
                    rank_name: 'Đại úy',
                },
                {
                    rank_id: 10,
                    rank_name: 'Thiếu tá',
                },
                {
                    rank_id: 11,
                    rank_name: 'Trung tá',
                },
                {
                    rank_id: 12,
                    rank_name: 'Thượng tá',
                },
                {
                    rank_id: 13,
                    rank_name: 'Đại tá',
                },
                {
                    rank_id: 14,
                    rank_name: 'Thiếu tướng',
                },
                {
                    rank_id: 15,
                    rank_name: 'Trung tướng',
                },
                {
                    rank_id: 16,
                    rank_name: 'Thượng tướng',
                },
                {
                    rank_id: 17,
                    rank_name: 'Đại tướng',
                },
            ]
            let rank = dataRank.find(value => {
                return value.rank_id === rank_id
            })

            if (rank) {
                return (
                    <Tag key="text" color={'green'}>
                        {rank.rank_name}
                    </Tag>
                )
            } else {
                return ''
            }
        }

        const renderAvatar = avatar => {
            if (avatar === '') avatar = default_avatar
            return (
                <img
                    src={avatar}
                    style={{ height: 43, width: 43, borderRadius: 22 }}
                    alt="img"
                />
            )
        }
        // render table
        const columns = [
            {
                align: 'center',
                title: 'Ảnh đại diện',
                dataIndex: 'avatar',
                key: Math.random()
                    .toString(36)
                    .slice(-5),
                render: renderAvatar,
            },
            {
                align: 'center',
                title: 'Tên hiển thị',
                dataIndex: 'display_name',
                key: Math.random()
                    .toString(36)
                    .slice(-5),
            },
            {
                align: 'center',
                title: 'Cấp bậc',
                dataIndex: 'rank_id',
                render: renderRankColumn,
                key: Math.random()
                    .toString(36)
                    .slice(-5),
            },
            {
                align: 'center',
                title: 'Chức Vụ',
                dataIndex: 'uid',
                key: Math.random()
                    .toString(36)
                    .slice(-5),
                render: renderPositionColumn,
            },
            {
                //align: 'center',
                title: 'Hành động',
                key: 'action',
                render: object => {
                    return (
                        <div>
                            <Button
                                size="small"
                                type="link"
                                style={{
                                    marginRight: 1,
                                    color: 'black',
                                    backgroundColor: '#b3e6ff',
                                }}
                                onClick={object.onDetail}
                            >
                                Chi tiết
                            </Button>
                        </div>
                    )
                },
            },
        ]

        // add event
        let complete_users = []
        listUserInOrgani.forEach(user => {
            let complete_user = {
                ...user,
                ...{
                    onDetail: () => this._onShowDetail(user),
                },
            }
            complete_users.push(complete_user)
        })

        return (
            <div>
                <Table
                    style={{
                        marginTop: 2,
                        overflowX: window.innerWidth < 768 ? 'scroll' : 'none',
                    }}
                    columns={columns}
                    dataSource={complete_users}
                    bordered
                    //pagination={false}
                    pagination={{ pageSize: 6 }}
                    rowKey="user_name"
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        listUserInOrgani: state.organization.listUserInOrgani,
        currentOrganization: state.organization.currentOrganization,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        showDetailModal: () => {
            dispatch(userActions.action.showModalCurrentUserInfo())
        },
        updateCurrentUser: user => {
            dispatch(userActions.action.updateCurrentUser(user))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListUsers)
